module.exports = __webpack_public_path__ + "static/img/sidekick_white.4cf20e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidekick_white.svg
// module id = dj6l
// module chunks = 1